import consumer from './cable';

$(document).ready(() => {
  if ($('#summary-contribution-id').length) {
    consumer.subscriptions.create(
      { channel: 'SummaryChannel', contribution_id: $('#summary-contribution-id').data('id') }, {
        received(data) {
          if (data.status == 'success') {
            let url = data.virtual_banking_coordinates_document_url;

            $('#bankingCoordinatesLink').attr('href', url);
            $('#iconLoader').addClass('d-none');
            $('#step-4').removeClass('d-none');
          } else {
            $('#iconLoader').addClass('d-none');
            $('#loadingError').removeClass('d-none');
          }
        }
      }
    );
  };
});
